module.exports = __webpack_public_path__ + "static/media/ico-applepodcasts.5fd7fe29.svg";